/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Boundary_DetailsInputs */

const en_error_boundary_details = /** @type {(inputs: Error_Boundary_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error details`)
};

const es_error_boundary_details = /** @type {(inputs: Error_Boundary_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del error`)
};

/**
* | output |
* | --- |
* | "Error details" |
*
* @param {Error_Boundary_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const error_boundary_details = /** @type {((inputs?: Error_Boundary_DetailsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Boundary_DetailsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_boundary_details(inputs)
	return es_error_boundary_details(inputs)
});